<template>
  <div
    id="hamburgerContainer"
    @click="toggleMobileMenu"
  >
    <div
      id="hamburger"
      :class="toggledMobileMenu ? 'open' : 'closed'"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationHamburger',
  props: {
    toggledMobileMenu: Boolean
  },
  methods: {
    toggleMobileMenu: function () {
      this.$emit('toggle-mobile-menu');
    }
  }
};
</script>
